import { useState } from "react";
import { motion } from "framer-motion";
import data from "../../data/index.json";
import "./MyExperienc.css";

export default function MyExperienc() {
  const placeholder =
    "data:image/svg+xml;charset=utf-8," +
    encodeURIComponent(
      `<svg xmlns='http://www.w3.org/2000/svg' width='200' height='140'><rect width='100%' height='100%' fill='#ececec'/><text x='50%' y='50%' dominant-baseline='middle' text-anchor='middle' font-family='Arial' font-size='14' fill='#bdbdbd'>No image</text></svg>`
    );

  // Framer Motion variants: parent controls stagger; children animate in
  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.12,
      },
    },
  };

  const cardVariant = {
    hidden: { opacity: 0, y: 18, scale: 0.995 },
    visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.5, ease: "easeOut" } },
  };

  return (
    <section
      id="myexperience"
      className="experiences-section"
      aria-labelledby="experiences-title"
    >
      <div className="experiences-header">
        <p className="sub-title">My Experiences</p>
        <h2 id="experiences-title" className="section-heading">
          Professional Experiences
        </h2>
        <p className="section-lead">
          Roles I’ve held, companies I’ve worked with and the technologies I used.
        </p>
      </div>

      <motion.div
        className="experiences-grid"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.15 }}
      >
        {data?.experiences?.length ? (
          data.experiences.map((item, idx) => (
            <motion.article
              key={item.id ?? idx}
              className="experience-card"
              variants={cardVariant}
              whileHover={{ y: -6, boxShadow: "0 18px 40px rgba(15,23,42,0.12)" }}
              role="article"
              aria-label={`${item.role} at ${item.company}`}
            >
              <div className="experience-media">
                <img
                  src={item.image ?? placeholder}
                  alt={item.company ? `${item.company} logo` : item.role}
                  loading="lazy"
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = placeholder;
                  }}
                />
              </div>

              <div className="experience-body">
                <div className="experience-top">
                  <h3 className="experience-role">{item.role}</h3>
                  <time className="experience-date" dateTime={item.date}>
                    {item.date}
                  </time>
                </div>

                <p className="experience-company">{item.company}</p>

                <p className="experience-desc">
                  {item.description}
                </p>
              </div>
            </motion.article>
          ))
        ) : (
          <div className="empty-msg">No experiences found.</div>
        )}
      </motion.div>
    </section>
  );
}
